<button
  #button
  class="container card-selector focus-link"
  (click)="click(pointsAccount)"
  [class.active]="active"
  type="button"
  tabindex="-1">
  <img class="img" [src]="imgUrl" alt="" />
  <span class="information">
    <span class="title"> {{ name }} </span>
    <span class="description"
      >{{ pointsBalance | localizePointsNumber: '1.0-0' }} {{ currency }}</span
    >
  </span>
</button>
